/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import {
  Box,
  Button,
  Card,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  Grid,
  Typography,
} from '@mui/material';
import _ from 'lodash';
import { withStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { colors } from '../../../helpers/colors';
import Backdrop from '@mui/material/Backdrop';

import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import orgStructure from '../../../api/orgStructure';
import { useTranslation } from 'react-i18next';
import { CustomToast } from '../../../common/Methodcommon';
import FetchImage from '../../Common/FetchImage';
import HrSearchComponents from '../../HRAdmin/components/HrSearchComponent';
const styles = {
  box: {
    backgroundColor: 'white',
    borderRadius: '0.8em',
    border: '1px solid #0000001F',
    padding: '1em',
    marginRight: '1em',
  },
  inner: {
    padding: 20,
  },
  boxBig: {
    backgroundColor: 'white',
    borderRadius: '0.8em',
    border: '1px solid #0000001F',
    padding: '1em',
    marginRight: '1em',
    height: '40vh',
    width: '100%',
  },
  modal: {
    boxShadow: 24,
    padding: '2.5em',
    borderRadius: '1em',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    width: '780px',
  },
  title: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    display: 'flex',
    flexDirection: 'row',
  },
  check: {
    color: '#A3A3A3',

    '&.Mui-checked': {
      color: '#7C0E6F',
      borderRadius: '1em',
    },
  },
  save: {
    boxShadow: 'none',
    textTransform: 'capitalize',
    fontSize: 14,
    color: 'white',
    padding: '6px 12px',
    border: '1px solid',
    lineHeight: 1.5,
    backgroundColor: '#7C0E6F',

    borderRadius: '0.5em',
    height: '42px',
    width: '164px',
    '&:hover': {
      backgroundColor: '#7C0E6F',
      boxShadow: 'none',
    },
    '&:active': {
      backgroundColor: '#7C0E6F',
    },
    '&:focus': {
      boxShadow: 'none',
    },
  },
  cancel: {
    boxShadow: 'none',
    textTransform: 'capitalize',
    fontSize: 14,
    color: '#FF5263',
    padding: '6px 12px',
    border: '1px solid',
    lineHeight: 1.5,
    backgroundColor: '#FFEDEF',

    borderRadius: '0.5em',
    height: '42px',
    width: '164px',
    '&:hover': {
      backgroundColor: '#FFEDEF',
      boxShadow: 'none',
    },
    '&:active': {
      backgroundColor: '#FFEDEF',
    },
    '&:focus': {
      boxShadow: 'none',
    },
  },
};

const EditRoleContent = (props) => {
  const { t } = useTranslation();
  const [user, setUserInfo] = useState({});
  const [reportees, setReportees] = useState([]);
  const [selectedReportees, setSelectedReportees] = useState([]);
  const [buttonText, setButtonText] = useState('Reset');
  const [company, setCompanyId] = useState(undefined);
  const [, setLoadingAvailableRole] = useState(false);
  const [searchText, setSearchText] = useState('');

  const handleSelectRoles = (event, id) => {
    if (selectedReportees.includes(id)) {
      let next = [...selectedReportees];

      let a = _.filter(next, function (p) {
        return p != id;
      });
      setSelectedReportees(a);
    } else {
      let next = [...selectedReportees];
      next.push(id);
      setSelectedReportees(next);
    }
  };
  const handleSelection = () => {
    if (reportees.length === selectedReportees.length) {
      handleUnSelectAll();
      setButtonText('Select All');
    } else {
      handleSelectAll();
      setButtonText('Reset');
    }
  };

  const handleCancel = () => {
    return props.onClose();
  };

  const handleSave = () => {
    const payload = {
      userIds: selectedReportees,
      companyId: company,
      userRoleId: user.id,
      ...(props.pageFrom ? { pageFrom: props.pageFrom } : {}),
    };
    orgStructure
      .patchReporting(payload)
      .then((result) => {
        props.onRefresh(result);
        handleCancel();
        CustomToast('success', result?.message || result);
        if (result?.pending) {
          props?.onHandlePending(result?.pending);
        }
      })
      .catch((err) => {
        console.log(err);
        CustomToast('error', t('Reporting Structure assignement Failed!'));
      });
  };
  const handleSelectAll = () => {
    const allIds = _.map(reportees, 'employee.id');
    setSelectedReportees(allIds);
  };
  const handleUnSelectAll = () => {
    setSelectedReportees([]);
  };

  useEffect(() => {
    orgStructure
      .getManagerReportees(
        props.record.user_id,
        props?.record.ManagerRoleId,
        props.pageFrom ? props.pageFrom : undefined,
      )
      .then((res) => {
        if (res.data) {
          console.log('res----------', res);
          const record = res.data[0];
          const reporteesKey =
            props.pageFrom === 'faceReportStructure'
              ? 'facereportees'
              : 'reportees';
          const currentCompanyReportees = (record[reporteesKey] || []).filter(
            (reportee) =>
              String(reportee.companyId) ===
              localStorage.getItem('__current_company_id'),
          );

          const allIds = _.map(currentCompanyReportees, 'employee.id');

          setSelectedReportees(allIds);
          const companyId = record.CompanyID;
          const reportees = currentCompanyReportees;
          const userDetail = {
            id: record.id,
            staff_id: record.ManagerStaffId,
            name: record.ManagerName,
            profile_pic: record.profile_pic,
            reportees: reportees,
            department: record.departmentName,
            BU: record.CompanyName,
            email: record.ManagerEmail,
            phone: '',
            active: 1,
            role: record.ManagerRoleName,
          };
          setUserInfo(userDetail);
          setCompanyId(companyId);
          setLoadingAvailableRole(true);

          setReportees(reportees);
        }
      })
      .catch(() => {});
  }, []);

  const filteredData = () => {
    if (searchText.length > 0) {
      const filtered = reportees.filter((reportee) => {
        const fullName =
          reportee.employee.first_name +
          ' ' +
          reportee.employee.last_name +
          ' ' +
          reportee.employee.staff_id;
        return fullName.toLowerCase().includes(searchText.toLowerCase());
      });
      return filtered;
    } else {
      return reportees;
    }
  };

  return (
    <Card elevation={0}>
      <Box style={{ display: 'flex', marginBottom: '2em' }}>
        <Box style={{ flex: 1 }}>
          <Typography className="welcome-text">
            {t('Edit\n')}
            <Typography display="inline" className="welcome-text2">
              {t('Reportees')}
            </Typography>
          </Typography>
        </Box>
        <i
          class="las la-times"
          style={{
            fontSize: '1.5em',
            color: colors.grey,
            cursor: 'pointer',
          }}
          onClick={props.onClose}
        ></i>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Box style={styles.box}>
            <Box>
              <Chip
                size="small"
                label={
                  <Typography
                    sx={{
                      fontSize: '11px',
                    }}
                  >{`#${user.staff_id}`}</Typography>
                }
                sx={{
                  color: '#8181A5',
                  backgroundColor: '#F5F5FA',
                }}
              />
            </Box>
            <Grid
              container
              spacing={1}
              direction="row"
              sx={{
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Grid
                item
                xs={12}
                sx={{
                  alignItems: 'center',
                  justifyContent: 'center',
                  display: 'flex',
                }}
              >
                <FetchImage
                  type={'avatar'}
                  src={user.profile_pic}
                  sx={{ width: 56, height: 56 }}
                  alt="User Profile"
                />
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  alignItems: 'center',
                  justifyContent: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Typography
                  sx={{
                    color: '#081735',

                    fontSize: '24px',
                  }}
                >
                  {user.name}
                </Typography>
                <Chip
                  label={
                    <Typography
                      variant="caption"
                      style={{
                        color: '#081735',

                        fontSize: '12px',
                      }}
                      s
                    >
                      {user.role}
                    </Typography>
                  }
                  size="small"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <Typography
                      variant="caption"
                      sx={{
                        color: '#8F95B2',
                      }}
                    >
                      {t('Department')}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: 12,
                      }}
                    >
                      {user.department}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sx={{
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                      display: 'flex',
                      flexDirection: 'column',
                      textAlign: 'flex-start',
                    }}
                  >
                    <Typography
                      variant="caption"
                      sx={{
                        color: '#8F95B2',
                      }}
                    >
                      {t('Business Unit')}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: 12,
                      }}
                    >
                      {user.BU}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container spacing={1} sx={{ marginTop: '1em' }}>
                  <Grid item xs={6}>
                    <Grid
                      container
                      spacing={0}
                      direction="column"
                      sx={{
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        display: 'flex',
                        flexDirection: 'row',
                      }}
                    >
                      <Grid
                        item
                        xs={6}
                        sx={{
                          alignItems: 'center',
                          justifyContent: 'center',
                          display: 'flex',
                          flexDirection: 'row',
                        }}
                      >
                        <i
                          class="las la-envelope"
                          style={{ color: '#8181A5' }}
                        ></i>
                        <Typography
                          variant="caption"
                          sx={{
                            fontSize: 12,
                          }}
                        >
                          {user.email}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    xs={6}
                    sx={{
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Chip
                      label={user.active ? t('Active') : t('Inactive')}
                      size="small"
                      sx={
                        user.active
                          ? {
                              backgroundColor: '#E5F8F4',
                              color: '#21D8A5',
                            }
                          : {
                              backgroundColor: '#f5f5f5',
                              color: '#000000',
                            }
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box style={styles.boxBig}>
            <Grid container spacing={2} direction="row">
              <Grid item xs={6}>
                <Typography
                  sx={{
                    color: '#7C0E6F',

                    fontSize: '14px',
                  }}
                >
                  {t('Select Reportees')}
                </Typography>
                <Typography variant="caption" sx={{ color: '#92929D' }}>
                  {t(`{{count1}}/{{count2}} selected`, {
                    count1: selectedReportees.length,
                    count2: reportees.length,
                  })}
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
                sx={{
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  display: 'flex',
                }}
              >
                <Button
                  size="small"
                  variant="outlined"
                  sx={{
                    fontSize: '0.6em',
                    color: '#21D8A5',
                    border: '1px solid #21D8A5',
                    borderRadius: '5px',
                    '&:hover': {
                      backgroundColor: 'white',
                      boxShadow: 'none',
                      border: '1px solid #21D8A5',
                    },

                    '&:focus': {
                      backgroundColor: 'white',
                      border: '1px solid #21D8A5',
                    },
                  }}
                  startIcon={
                    <i class="las la-plus" style={{ color: '#21D8A5' }}></i>
                  }
                  onClick={handleSelection}
                >
                  {t(buttonText)}
                </Button>
              </Grid>
            </Grid>

            <Grid
              container
              sx={{
                marginTop: '1em',
                padding: 1,
                overflowY: 'scroll',
                height: '30vh',
              }}
            >
              <div className="mb-2">
                <HrSearchComponents onChange={setSearchText} />
              </div>
              <Grid item xs={12} style={{ overflowX: 'hidden' }}>
                <FormControl
                  component="fieldset"
                  variant="standard"
                  fullWidth
                  style={{ width: 300 }}
                  key={selectedReportees.length}
                >
                  {_.map(filteredData(), function (reportee) {
                    return (
                      <FormControlLabel
                        key={reportee.employee.id}
                        sx={{
                          backgroundColor: '#fafafa',
                          padding: 1,
                          marginBottom: 1,
                        }}
                        control={
                          <Checkbox
                            size="small"
                            sx={{
                              color: '#A3A3A3',

                              '&.Mui-checked': {
                                color: '#7C0E6F',
                              },
                            }}
                            onChange={(e) =>
                              handleSelectRoles(e, reportee.employee.id)
                            }
                            checked={selectedReportees.includes(
                              reportee.employee.id,
                            )}
                          />
                        }
                        value={reportee.employee.id}
                        label={
                          <>
                            <Typography
                              sx={{
                                color: '#464545',

                                fontSize: 14,
                              }}
                            >
                              {reportee.employee.first_name +
                                ' ' +
                                reportee.employee.last_name}
                            </Typography>
                            <Typography
                              sx={{
                                color: '#464545',

                                fontSize: 10,
                              }}
                            >
                              {reportee.employee
                                ? reportee.employee.staff_id
                                : ''}
                            </Typography>
                          </>
                        }
                      />
                    );
                  })}
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{
          marginTop: 5,
          alignItems: 'center',
          justifyContent: 'space-between',
          display: 'flex',
          padding: 2,
        }}
      >
        <Grid item xs={6}>
          <Button onClick={handleCancel} style={styles.cancel}>
            {t('Cancel')}
          </Button>
        </Grid>
        <Grid
          item
          xs={6}
          style={{ justifyContent: 'flex-end', display: 'flex' }}
        >
          <Button style={styles.save} onClick={handleSave}>
            {t('SAVE')}
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
};

const EditManager = (props) => {
  const [open, setOpen] = React.useState(props.open);

  const handleClose = () => {
    setOpen(false);
    props.onClose();
  };
  useEffect(() => {
    setOpen(props.open);
  }, []);
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={props.open}>
          <Box sx={styles.modal}>
            <EditRoleContent
              onClose={handleClose}
              record={props.record}
              onRefresh={props.onRefresh}
              onHandlePending={props?.onHandlePending}
              pageFrom={props?.pageFrom}
            />
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default withStyles(styles)(EditManager);
